<template>
  <div class="h-full overflow-hidden rounded-sm  bg-white text-gray-600 shadow-lg px-10 py-5 text-left">
  <!-- server message -->
  <p class="mb-2 animate__animated text-center" :class="serverMessage.err ? ['border rounded-sm overflow-hidden border-pink-500 bg-pink-100 p-2 text-pink-500 animate__headShake'] : ['animate__rubberBand border rounded-sm overflow-hidden border-green-500 bg-green-100 p-2 text-green-500'] " v-if="serverMessage.val" v-html="serverMessage.val"></p>

  <h1 class="text-2xl font-extralight">Delivery Information</h1>
  <hr>
  <p class="my-2 mb-4 text-sm">Please ensure to enter a valid information to avoid inconvenience </p>
  
  <div class="font-mono text-sm font-thin w-6/12 bg-blue-100 border-dashed border-4 border-blue-500 m-auto p-5">
    <p class="w-full"><span class="font-bold">Name</span>: {{ firstName.val + " " + middleName.val + " " + lastName.val }}</p>
    <p class="w-full"><span class="font-bold">Phone Number</span>: {{ phoneNumber.val }}</p>
    <p class="w-full"><span class="font-bold">Email Address</span>: {{ emailAddress.val }}</p>
    <p class="w-full"><span class="font-bold">Delivery Address</span>: {{ address.val }}</p>
  </div>
  <form @submit.prevent="submitForm">
    
    <!-- name -->
    <p class="text-left font-bold my-2">Name</p>
    <div class="flex items-center justify-start w-full">
      <div class="w-full flex items-center justify-start rounded-md border p-2 border-gray-500">
        <input class="flex-auto placeholder-gray-500 focus:placeholder-gray-300" type="text" :name="firstName.name"  :placeholder="firstName.name" v-model.trim="firstName.val">
      </div>
      <div class="w-full flex items-center justify-start rounded-md border p-2 mx-2 border-gray-500">
        <input class="flex-auto placeholder-gray-500 focus:placeholder-gray-300" type="text" :name="middleName.name"  :placeholder="middleName.name" v-model.trim="middleName.val">
      </div>
      <div class="w-full flex items-center justify-start rounded-md border p-2 border-gray-500">
        <input class="flex-auto placeholder-gray-500 focus:placeholder-gray-300" type="text" :name="lastName.name"  :placeholder="lastName.name" v-model.trim="lastName.val">
      </div>
    </div>
    <p class="animate__animated animate__headShake text-left text-pink-500" v-if="firstName.err">{{firstName.err}}</p>

    <!-- phone number -->
    <p class="text-left font-bold my-2">Phone Number</p>
    <div class="flex items-center justify-start">
      <div class="w-full flex items-center justify-start rounded-md border p-2 border-gray-500">
        <input class="flex-auto placeholder-gray-500 focus:placeholder-gray-300" type="text" :name="phoneNumber.name"  :placeholder="phoneNumber.name" v-model.trim="phoneNumber.val">
      </div>
    </div>
    <p class="animate__animated animate__headShake text-left text-pink-500" v-if="phoneNumber.err">{{phoneNumber.err}}</p>

    <!-- email address -->
    <p class="text-left font-bold my-2 flex items-center justify-start">
      Email Address 
      <span class="ml-1" title="Read only.">
          <svg alt="reaonly" xmlns="http://www.w3.org/2000/svg" class="h-5" viewBox="0 0 24 24" style="fill:currentColor;transform:;-ms-filter:"><path d="M12,2C6.486,2,2,6.486,2,12s4.486,10,10,10s10-4.486,10-10S17.514,2,12,2z M12,20c-4.411,0-8-3.589-8-8s3.589-8,8-8 s8,3.589,8,8S16.411,20,12,20z"></path><path d="M11 11H13V17H11zM11 7H13V9H11z"></path></svg>
      </span>
    </p>
    <div title="Read only." class="cursor-not-allowed w-full flex items-center justify-start rounded-md border p-2 border-gray-400 text-gray-400">
      <p class="flex-auto">{{emailAddress.val}}</p>
    </div>

    <!-- address -->
    <p class="text-left font-bold my-2">Delivery Address</p>
    <div class="flex items-center justify-start">
      <div class="w-full flex items-center justify-start rounded-md border p-2 border-gray-500">
        <input class="flex-auto placeholder-gray-500 focus:placeholder-gray-300" type="text" :name="address.name"  :placeholder="address.name" v-model.trim="address.val">
      </div>
    </div>
    <p class="animate__animated animate__headShake text-left text-pink-500" v-if="address.err">{{address.err}}</p>

    <div class="flex items-center justify-end mt-5">
      <router-link  class="rounded-md p-2 px-4" to="/">Cancel</router-link>
      <button type="submit" class=" w-2/12 bg-blue-700 hover:bg-blue-600 text-white font-bold rounded-md p-2">Update</button>
    </div>

  </form> 

</div>  
</template>

<script>
import { ref } from 'vue';
import { useStore } from 'vuex';

export default {
  setup() {

    const store = useStore();

    const firstName = ref({
      name:"First Name",
      val:"",
      err:"",
    });
    
    const lastName = ref({
      name:"Last Name",
      val:"",
      err:"",
    });
    
    const middleName = ref({
      name:"Middle Name",
      val:"",
      err:"",
    });
    
    const phoneNumber = ref({
      name:"Phone Number",
      val:"",
      err:"",
    });
    
    const emailAddress = ref({
      name:"Email Address",
      val:"",
      err:"",
    });

    const address = ref({
      name:"Delivery Address",
      val:"",
      err:"",
    });

    const serverMessage = ref({
      val:"",
      err: false,
    })
    
    async function submitForm(){
      const hasNoChanges = await checkChanges(); 
      if(hasNoChanges){
        const isReset = await resetError(); 
        if(isReset){
          const isValidated = await validateForm();
          if(isValidated){

            const form = {
              firstName : firstName.value.val,
              middleName : middleName.value.val,
              lastName : lastName.value.val,
              phoneNumber : phoneNumber.value.val,
              address : address.value.val,
            }

            try {
              const data = await store.dispatch("accountModule/accountForm", form);
              serverMessage.value.val = data.message;
                setTimeout(() => {
                  clearServerMessage();
              }, 5000);

              firstNameTemp.value = firstName.value.val;
              middleNameTemp.value = middleName.value.val;
              lastNameTemp.value = lastName.value.val;
              phoneNumberTemp.value = phoneNumber.value.val;
              addressTemp.value = address.value.val;

            } catch (error) {
              console.log(error);
              if(error.msg){
                serverMessage.value.val = error.msg;
                serverMessage.value.err = true;
                setTimeout(() => {
                  clearServerMessage();
                }, 3000);
              } 

              if(error.errors){
                error.errors.forEach(element => {
                  this[element.param].err = element.msg;
                });
              }
            }
          }
        }
      }else{
        serverMessage.value.val = "No changes to the delivery information were detected."
        serverMessage.value.err = true;
        setTimeout(() => {
          clearServerMessage();
        }, 3000);
      }
    }

    function clearServerMessage(){
      serverMessage.value.val = "";
      serverMessage.value.err = false;
    }

    function resetError(){
      return new Promise((resolve)=>{
        firstName.value.err = "";
        lastName.value.err = "";
        middleName.value.err = "";
        phoneNumber.value.err = "";
        emailAddress.value.err = "";
        address.value.err = "";
        resolve(true);
      })  
    }

    // REGEX
    const REGEX = {
       EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line
      ,NAME: /^[a-zA-Z0-9_]*$/ // eslint-disable-line
      ,PHONE_NUM: /^(\+)?.[0-9 ]*$/ // eslint-disable-line
      ,PHONE: /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/ // eslint-disable-line
      ,PASSWORD_U: /^(?=.*[A-Z]).{0,}$/ // eslint-disable-line
      ,PASSWORD_L: /^(?=.*[a-z]).{0,}$/ // eslint-disable-line
      ,PASSWORD_D: /^(?=.*[0-9]).{0,}$/ // eslint-disable-line
      ,PASSWORD_S: /^(?=.*[!@#?]).{0,}$/ // eslint-disable-line
    }
    
    function validateForm(){
      return new Promise((resolve)=>{

        const requireStr = " is required.";
        const invalidStr = " is invalid.";

        // first name
        if(!firstName.value.val){
          firstName.value.err =  "Name" + requireStr;
        }else if(!REGEX.NAME.test(firstName.value.val)){
          firstName.value.err =  "Name" + invalidStr;
        }

        // middle name
        if(!middleName.value.val){
          firstName.value.err =  "Name" + requireStr;
        }else if(!REGEX.NAME.test(middleName.value.val)){
          firstName.value.err =  "Name" + invalidStr;
        }

        // last name
        if(!lastName.value.val){
          firstName.value.err =  "Name" + requireStr;
        }else if(!REGEX.NAME.test(lastName.value.val)){
          firstName.value.err =  "Name" + invalidStr;
        }


        // phone number
        if(!phoneNumber.value.val){
          phoneNumber.value.err =  phoneNumber.value.name + requireStr;
        }else if(!REGEX.PHONE_NUM.test(phoneNumber.value.val)){
          phoneNumber.value.err =  phoneNumber.value.name + invalidStr;
        }

        // address
        if(!address.value.val){
          address.value.err =  address.value.name + requireStr;
        }

        resolve(!emailAddress.value.err && !firstName.value.err && !middleName.value.err && !lastName.value.err && !phoneNumber.value.err && !address.value.err);

      })  
    }

    const firstNameTemp = ref("");
    const middleNameTemp = ref("");
    const lastNameTemp = ref("");
    const phoneNumberTemp = ref("");
    const addressTemp = ref("");

    async function loadAccountInformation(){
      try {
        const { user } = await store.dispatch("accountModule/loadAccount")   
          firstName.value.val = user.firstName;     
          middleName.value.val = user.middleName;     
          lastName.value.val = user.lastName;    
          phoneNumber.value.val = user.phoneNumber;   
          emailAddress.value.val = user.emailAddress;
          address.value.val = user.address;  

          firstNameTemp.value = firstName.value.val;
          middleNameTemp.value = middleName.value.val;
          lastNameTemp.value = lastName.value.val;
          phoneNumberTemp.value = phoneNumber.value.val;
          addressTemp.value = address.value.val;

      } catch (error) {
        if(error.msg){
          serverMessage.value.val = error.msg;
          serverMessage.value.err = true;
          setTimeout(() => {
            clearServerMessage();
          }, 3000);
        } 
      }
    }
      
    loadAccountInformation();

    function checkChanges(){
      return new Promise((resolve)=>{
        console.log(
          firstNameTemp.value, firstName.value.val,
          middleNameTemp.value, middleName.value.val,
          lastNameTemp.value, lastName.value.val,
          phoneNumberTemp.value, phoneNumber.value.val,
          addressTemp.value, address.value.val
        )
        resolve( !
          (firstNameTemp.value == firstName.value.val && 
          middleNameTemp.value == middleName.value.val && 
          lastNameTemp.value == lastName.value.val && 
          phoneNumberTemp.value == phoneNumber.value.val && 
          addressTemp.value == address.value.val)
        )
      })  
    }

    return{
      firstName, lastName, middleName, address, phoneNumber, emailAddress, submitForm, serverMessage
    }

    
  }
}
</script>

<style>
/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill:rgba(0, 0, 0, 1);transform:;-ms-filter:"><path d="M20.205,4.791c-1.137-1.131-2.631-1.754-4.209-1.754c-1.483,0-2.892,0.552-3.996,1.558 c-1.104-1.006-2.512-1.558-3.996-1.558c-1.578,0-3.072,0.623-4.213,1.758c-2.353,2.363-2.352,6.059,0.002,8.412L12,21.414 l8.207-8.207C22.561,10.854,22.562,7.158,20.205,4.791z"></path></svg> */
</style>